import {Typography} from '@mui/material';
import {t} from 'i18next';
import ArrModal from '../../../../common/arr-modal/ArrModal';

interface DiscardRevisionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DiscardRevisionModal = ({
  open,
  onClose,
  onConfirm,
}: DiscardRevisionModalProps) => {
  return (
    <ArrModal
      showModal={open}
      onClose={onClose}
      showClose={false}
      title={t('ai.review.protocolIntelligence.discardRevisionModalTitle')}
      aria-label="discard-revision-modal"
      dataTestId="discard-revision-modal"
      buttons={[
        {
          id: 'discard-revision-cancel',
          label: t('ai.review.protocolIntelligence.discardRevisionModalCancel'),
          onClick: onClose,
          variant: 'secondary',
          dataTestId: 'discard-revision-modal-cancel',
        },
        {
          id: 'discard-revision-confirm',
          label: t(
            'ai.review.protocolIntelligence.discardRevisionModalConfirm'
          ),
          onClick: onConfirm,
          variant: 'primary',
          dataTestId: 'discard-revision-modal-confirm',
        },
      ]}
    >
      <Typography
        className="typo-text body2_size text-body-strong"
        data-testid="discard-revision-modal-description"
      >
        {t('ai.review.protocolIntelligence.discardRevisionModalDescription')}
      </Typography>
    </ArrModal>
  );
};

export default DiscardRevisionModal;
